/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root'
import { Route as publicIndexRouteImport } from './app/routes/(public)/index'
import { Route as publicSignUpRouteImport } from './app/routes/(public)/sign-up'
import { Route as publicResetPasswordRouteImport } from './app/routes/(public)/reset-password'
import { Route as publicOnboardingRouteImport } from './app/routes/(public)/onboarding'
import { Route as publicNotFoundRouteImport } from './app/routes/(public)/not-found'
import { Route as publicLoginRouteImport } from './app/routes/(public)/login'
import { Route as publicHealthRouteImport } from './app/routes/(public)/health'
import { Route as publicForgotPasswordRouteImport } from './app/routes/(public)/forgot-password'
import { Route as publicConfirmEmailRouteImport } from './app/routes/(public)/confirm-email'
import { Route as protectedLayoutRouteImport } from './app/routes/(protected)/_layout'
import { Route as publicOnboardingRegionsRouteImport } from './app/routes/(public)/onboarding/regions'
import { Route as publicOnboardingPlanRouteImport } from './app/routes/(public)/onboarding/plan'
import { Route as publicOnboardingOrganizationRouteImport } from './app/routes/(public)/onboarding/organization'
import { Route as publicOnboardingLocationsRouteImport } from './app/routes/(public)/onboarding/locations'
import { Route as publicOnboardingInviteRouteImport } from './app/routes/(public)/onboarding/invite'
import { Route as publicOnboardingCompanyRouteImport } from './app/routes/(public)/onboarding/company'
import { Route as protectedLayoutWorkingRouteImport } from './app/routes/(protected)/_layout/working'
import { Route as protectedLayoutUnauthorizedRouteImport } from './app/routes/(protected)/_layout/unauthorized'
import { Route as protectedLayoutSettingsRouteImport } from './app/routes/(protected)/_layout/settings'
import { Route as protectedLayoutRolespermsRouteImport } from './app/routes/(protected)/_layout/rolesperms'
import { Route as protectedLayoutProfileRouteImport } from './app/routes/(protected)/_layout/profile'
import { Route as protectedLayoutPrepRouteImport } from './app/routes/(protected)/_layout/prep'
import { Route as protectedLayoutOrganizationsRouteImport } from './app/routes/(protected)/_layout/organizations'
import { Route as protectedLayoutOrdersRouteImport } from './app/routes/(protected)/_layout/orders'
import { Route as protectedLayoutNewOrderRouteImport } from './app/routes/(protected)/_layout/new-order'
import { Route as protectedLayoutMultiViewRouteImport } from './app/routes/(protected)/_layout/multi-view'
import { Route as protectedLayoutImpersonateRouteImport } from './app/routes/(protected)/_layout/impersonate'
import { Route as protectedLayoutEquipmentRouteImport } from './app/routes/(protected)/_layout/equipment'
import { Route as protectedLayoutDashboardRouteImport } from './app/routes/(protected)/_layout/dashboard'
import { Route as protectedLayoutAdminRouteImport } from './app/routes/(protected)/_layout/admin'
import { Route as protectedLayoutOrgRouteImport } from './app/routes/(protected)/_layout/_org'
import { Route as protectedLayoutRecipesIndexRouteImport } from './app/routes/(protected)/_layout/recipes/index'
import { Route as protectedLayoutMenusIndexRouteImport } from './app/routes/(protected)/_layout/menus/index'
import { Route as protectedLayoutMaterialsIndexRouteImport } from './app/routes/(protected)/_layout/materials/index'
import { Route as protectedLayoutHelpCenterIndexRouteImport } from './app/routes/(protected)/_layout/help-center/index'
import { Route as protectedLayoutAdminIndexRouteImport } from './app/routes/(protected)/_layout/admin/index'
import { Route as protectedLayoutUsersUserIdRouteImport } from './app/routes/(protected)/_layout/users_.$userId'
import { Route as protectedLayoutSupportCleanupRouteImport } from './app/routes/(protected)/_layout/support/cleanup'
import { Route as protectedLayoutRegionsRegionIdRouteImport } from './app/routes/(protected)/_layout/regions_.$regionId'
import { Route as protectedLayoutRecipesRecipeIdRouteImport } from './app/routes/(protected)/_layout/recipes/$recipeId'
import { Route as protectedLayoutMenusMenuItemIdRouteImport } from './app/routes/(protected)/_layout/menus/$menuItemId'
import { Route as protectedLayoutMaterialsMaterialIdRouteImport } from './app/routes/(protected)/_layout/materials/$materialId'
import { Route as protectedLayoutLocationsLocationIdRouteImport } from './app/routes/(protected)/_layout/locations_.$locationId'
import { Route as protectedLayoutHelpCenterArticleIdRouteImport } from './app/routes/(protected)/_layout/help-center/$articleId'
import { Route as protectedLayoutCompaniesCompanyIdRouteImport } from './app/routes/(protected)/_layout/companies_.$companyId'
import { Route as protectedLayoutAdminMenusRouteImport } from './app/routes/(protected)/_layout/admin/menus'
import { Route as protectedLayoutAdminAuditRouteImport } from './app/routes/(protected)/_layout/admin/audit'
import { Route as protectedLayoutOrgRolesRouteImport } from './app/routes/(protected)/_layout/_org/roles'
import { Route as protectedLayoutOrgRegionsRouteImport } from './app/routes/(protected)/_layout/_org/regions'
import { Route as protectedLayoutOrgUsersIndexRouteImport } from './app/routes/(protected)/_layout/_org/users/index'
import { Route as protectedLayoutOrgLocationsIndexRouteImport } from './app/routes/(protected)/_layout/_org/locations/index'
import { Route as protectedLayoutOrgCompaniesIndexRouteImport } from './app/routes/(protected)/_layout/_org/companies/index'
import { Route as protectedLayoutRecipesRecipeIdEditRouteImport } from './app/routes/(protected)/_layout/recipes/$recipeId_.edit'

const publicIndexRoute = publicIndexRouteImport.update({
  id: '/(public)/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const publicSignUpRoute = publicSignUpRouteImport.update({
  id: '/(public)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const publicResetPasswordRoute = publicResetPasswordRouteImport.update({
  id: '/(public)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const publicOnboardingRoute = publicOnboardingRouteImport.update({
  id: '/(public)/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const publicNotFoundRoute = publicNotFoundRouteImport.update({
  id: '/(public)/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const publicLoginRoute = publicLoginRouteImport.update({
  id: '/(public)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const publicHealthRoute = publicHealthRouteImport.update({
  id: '/(public)/health',
  path: '/health',
  getParentRoute: () => rootRouteImport,
} as any)
const publicForgotPasswordRoute = publicForgotPasswordRouteImport.update({
  id: '/(public)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const publicConfirmEmailRoute = publicConfirmEmailRouteImport.update({
  id: '/(public)/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => rootRouteImport,
} as any)
const protectedLayoutRoute = protectedLayoutRouteImport.update({
  id: '/(protected)/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const publicOnboardingRegionsRoute = publicOnboardingRegionsRouteImport.update({
  id: '/regions',
  path: '/regions',
  getParentRoute: () => publicOnboardingRoute,
} as any)
const publicOnboardingPlanRoute = publicOnboardingPlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => publicOnboardingRoute,
} as any)
const publicOnboardingOrganizationRoute =
  publicOnboardingOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => publicOnboardingRoute,
  } as any)
const publicOnboardingLocationsRoute =
  publicOnboardingLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => publicOnboardingRoute,
  } as any)
const publicOnboardingInviteRoute = publicOnboardingInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => publicOnboardingRoute,
} as any)
const publicOnboardingCompanyRoute = publicOnboardingCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => publicOnboardingRoute,
} as any)
const protectedLayoutWorkingRoute = protectedLayoutWorkingRouteImport.update({
  id: '/working',
  path: '/working',
  getParentRoute: () => protectedLayoutRoute,
} as any)
const protectedLayoutUnauthorizedRoute =
  protectedLayoutUnauthorizedRouteImport.update({
    id: '/unauthorized',
    path: '/unauthorized',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutSettingsRoute = protectedLayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => protectedLayoutRoute,
} as any)
const protectedLayoutRolespermsRoute =
  protectedLayoutRolespermsRouteImport.update({
    id: '/rolesperms',
    path: '/rolesperms',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutProfileRoute = protectedLayoutProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => protectedLayoutRoute,
} as any)
const protectedLayoutPrepRoute = protectedLayoutPrepRouteImport.update({
  id: '/prep',
  path: '/prep',
  getParentRoute: () => protectedLayoutRoute,
} as any)
const protectedLayoutOrganizationsRoute =
  protectedLayoutOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutOrdersRoute = protectedLayoutOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => protectedLayoutRoute,
} as any)
const protectedLayoutNewOrderRoute = protectedLayoutNewOrderRouteImport.update({
  id: '/new-order',
  path: '/new-order',
  getParentRoute: () => protectedLayoutRoute,
} as any)
const protectedLayoutMultiViewRoute =
  protectedLayoutMultiViewRouteImport.update({
    id: '/multi-view',
    path: '/multi-view',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutImpersonateRoute =
  protectedLayoutImpersonateRouteImport.update({
    id: '/impersonate',
    path: '/impersonate',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutEquipmentRoute =
  protectedLayoutEquipmentRouteImport.update({
    id: '/equipment',
    path: '/equipment',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutDashboardRoute =
  protectedLayoutDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutAdminRoute = protectedLayoutAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => protectedLayoutRoute,
} as any)
const protectedLayoutOrgRoute = protectedLayoutOrgRouteImport.update({
  id: '/_org',
  getParentRoute: () => protectedLayoutRoute,
} as any)
const protectedLayoutRecipesIndexRoute =
  protectedLayoutRecipesIndexRouteImport.update({
    id: '/recipes/',
    path: '/recipes/',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutMenusIndexRoute =
  protectedLayoutMenusIndexRouteImport.update({
    id: '/menus/',
    path: '/menus/',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutMaterialsIndexRoute =
  protectedLayoutMaterialsIndexRouteImport.update({
    id: '/materials/',
    path: '/materials/',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutHelpCenterIndexRoute =
  protectedLayoutHelpCenterIndexRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutAdminIndexRoute =
  protectedLayoutAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => protectedLayoutAdminRoute,
  } as any)
const protectedLayoutUsersUserIdRoute =
  protectedLayoutUsersUserIdRouteImport.update({
    id: '/users_/$userId',
    path: '/users/$userId',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutSupportCleanupRoute =
  protectedLayoutSupportCleanupRouteImport.update({
    id: '/support/cleanup',
    path: '/support/cleanup',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutRegionsRegionIdRoute =
  protectedLayoutRegionsRegionIdRouteImport.update({
    id: '/regions_/$regionId',
    path: '/regions/$regionId',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutRecipesRecipeIdRoute =
  protectedLayoutRecipesRecipeIdRouteImport.update({
    id: '/recipes/$recipeId',
    path: '/recipes/$recipeId',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutMenusMenuItemIdRoute =
  protectedLayoutMenusMenuItemIdRouteImport.update({
    id: '/menus/$menuItemId',
    path: '/menus/$menuItemId',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutMaterialsMaterialIdRoute =
  protectedLayoutMaterialsMaterialIdRouteImport.update({
    id: '/materials/$materialId',
    path: '/materials/$materialId',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutLocationsLocationIdRoute =
  protectedLayoutLocationsLocationIdRouteImport.update({
    id: '/locations_/$locationId',
    path: '/locations/$locationId',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutHelpCenterArticleIdRoute =
  protectedLayoutHelpCenterArticleIdRouteImport.update({
    id: '/help-center/$articleId',
    path: '/help-center/$articleId',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutCompaniesCompanyIdRoute =
  protectedLayoutCompaniesCompanyIdRouteImport.update({
    id: '/companies_/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => protectedLayoutRoute,
  } as any)
const protectedLayoutAdminMenusRoute =
  protectedLayoutAdminMenusRouteImport.update({
    id: '/menus',
    path: '/menus',
    getParentRoute: () => protectedLayoutAdminRoute,
  } as any)
const protectedLayoutAdminAuditRoute =
  protectedLayoutAdminAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => protectedLayoutAdminRoute,
  } as any)
const protectedLayoutOrgRolesRoute = protectedLayoutOrgRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => protectedLayoutOrgRoute,
} as any)
const protectedLayoutOrgRegionsRoute =
  protectedLayoutOrgRegionsRouteImport.update({
    id: '/regions',
    path: '/regions',
    getParentRoute: () => protectedLayoutOrgRoute,
  } as any)
const protectedLayoutOrgUsersIndexRoute =
  protectedLayoutOrgUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => protectedLayoutOrgRoute,
  } as any)
const protectedLayoutOrgLocationsIndexRoute =
  protectedLayoutOrgLocationsIndexRouteImport.update({
    id: '/locations/',
    path: '/locations/',
    getParentRoute: () => protectedLayoutOrgRoute,
  } as any)
const protectedLayoutOrgCompaniesIndexRoute =
  protectedLayoutOrgCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => protectedLayoutOrgRoute,
  } as any)
const protectedLayoutRecipesRecipeIdEditRoute =
  protectedLayoutRecipesRecipeIdEditRouteImport.update({
    id: '/recipes/$recipeId_/edit',
    path: '/recipes/$recipeId/edit',
    getParentRoute: () => protectedLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/confirm-email': typeof publicConfirmEmailRoute
  '/forgot-password': typeof publicForgotPasswordRoute
  '/health': typeof publicHealthRoute
  '/login': typeof publicLoginRoute
  '/not-found': typeof publicNotFoundRoute
  '/onboarding': typeof publicOnboardingRouteWithChildren
  '/reset-password': typeof publicResetPasswordRoute
  '/sign-up': typeof publicSignUpRoute
  '/': typeof publicIndexRoute
  '/admin': typeof protectedLayoutAdminRouteWithChildren
  '/dashboard': typeof protectedLayoutDashboardRoute
  '/equipment': typeof protectedLayoutEquipmentRoute
  '/impersonate': typeof protectedLayoutImpersonateRoute
  '/multi-view': typeof protectedLayoutMultiViewRoute
  '/new-order': typeof protectedLayoutNewOrderRoute
  '/orders': typeof protectedLayoutOrdersRoute
  '/organizations': typeof protectedLayoutOrganizationsRoute
  '/prep': typeof protectedLayoutPrepRoute
  '/profile': typeof protectedLayoutProfileRoute
  '/rolesperms': typeof protectedLayoutRolespermsRoute
  '/settings': typeof protectedLayoutSettingsRoute
  '/unauthorized': typeof protectedLayoutUnauthorizedRoute
  '/working': typeof protectedLayoutWorkingRoute
  '/onboarding/company': typeof publicOnboardingCompanyRoute
  '/onboarding/invite': typeof publicOnboardingInviteRoute
  '/onboarding/locations': typeof publicOnboardingLocationsRoute
  '/onboarding/organization': typeof publicOnboardingOrganizationRoute
  '/onboarding/plan': typeof publicOnboardingPlanRoute
  '/onboarding/regions': typeof publicOnboardingRegionsRoute
  '/regions': typeof protectedLayoutOrgRegionsRoute
  '/roles': typeof protectedLayoutOrgRolesRoute
  '/admin/audit': typeof protectedLayoutAdminAuditRoute
  '/admin/menus': typeof protectedLayoutAdminMenusRoute
  '/companies/$companyId': typeof protectedLayoutCompaniesCompanyIdRoute
  '/help-center/$articleId': typeof protectedLayoutHelpCenterArticleIdRoute
  '/locations/$locationId': typeof protectedLayoutLocationsLocationIdRoute
  '/materials/$materialId': typeof protectedLayoutMaterialsMaterialIdRoute
  '/menus/$menuItemId': typeof protectedLayoutMenusMenuItemIdRoute
  '/recipes/$recipeId': typeof protectedLayoutRecipesRecipeIdRoute
  '/regions/$regionId': typeof protectedLayoutRegionsRegionIdRoute
  '/support/cleanup': typeof protectedLayoutSupportCleanupRoute
  '/users/$userId': typeof protectedLayoutUsersUserIdRoute
  '/admin/': typeof protectedLayoutAdminIndexRoute
  '/help-center/': typeof protectedLayoutHelpCenterIndexRoute
  '/materials/': typeof protectedLayoutMaterialsIndexRoute
  '/menus/': typeof protectedLayoutMenusIndexRoute
  '/recipes/': typeof protectedLayoutRecipesIndexRoute
  '/recipes/$recipeId/edit': typeof protectedLayoutRecipesRecipeIdEditRoute
  '/companies/': typeof protectedLayoutOrgCompaniesIndexRoute
  '/locations/': typeof protectedLayoutOrgLocationsIndexRoute
  '/users/': typeof protectedLayoutOrgUsersIndexRoute
}
export interface FileRoutesByTo {
  '/confirm-email': typeof publicConfirmEmailRoute
  '/forgot-password': typeof publicForgotPasswordRoute
  '/health': typeof publicHealthRoute
  '/login': typeof publicLoginRoute
  '/not-found': typeof publicNotFoundRoute
  '/onboarding': typeof publicOnboardingRouteWithChildren
  '/reset-password': typeof publicResetPasswordRoute
  '/sign-up': typeof publicSignUpRoute
  '/': typeof publicIndexRoute
  '/dashboard': typeof protectedLayoutDashboardRoute
  '/equipment': typeof protectedLayoutEquipmentRoute
  '/impersonate': typeof protectedLayoutImpersonateRoute
  '/multi-view': typeof protectedLayoutMultiViewRoute
  '/new-order': typeof protectedLayoutNewOrderRoute
  '/orders': typeof protectedLayoutOrdersRoute
  '/organizations': typeof protectedLayoutOrganizationsRoute
  '/prep': typeof protectedLayoutPrepRoute
  '/profile': typeof protectedLayoutProfileRoute
  '/rolesperms': typeof protectedLayoutRolespermsRoute
  '/settings': typeof protectedLayoutSettingsRoute
  '/unauthorized': typeof protectedLayoutUnauthorizedRoute
  '/working': typeof protectedLayoutWorkingRoute
  '/onboarding/company': typeof publicOnboardingCompanyRoute
  '/onboarding/invite': typeof publicOnboardingInviteRoute
  '/onboarding/locations': typeof publicOnboardingLocationsRoute
  '/onboarding/organization': typeof publicOnboardingOrganizationRoute
  '/onboarding/plan': typeof publicOnboardingPlanRoute
  '/onboarding/regions': typeof publicOnboardingRegionsRoute
  '/regions': typeof protectedLayoutOrgRegionsRoute
  '/roles': typeof protectedLayoutOrgRolesRoute
  '/admin/audit': typeof protectedLayoutAdminAuditRoute
  '/admin/menus': typeof protectedLayoutAdminMenusRoute
  '/companies/$companyId': typeof protectedLayoutCompaniesCompanyIdRoute
  '/help-center/$articleId': typeof protectedLayoutHelpCenterArticleIdRoute
  '/locations/$locationId': typeof protectedLayoutLocationsLocationIdRoute
  '/materials/$materialId': typeof protectedLayoutMaterialsMaterialIdRoute
  '/menus/$menuItemId': typeof protectedLayoutMenusMenuItemIdRoute
  '/recipes/$recipeId': typeof protectedLayoutRecipesRecipeIdRoute
  '/regions/$regionId': typeof protectedLayoutRegionsRegionIdRoute
  '/support/cleanup': typeof protectedLayoutSupportCleanupRoute
  '/users/$userId': typeof protectedLayoutUsersUserIdRoute
  '/admin': typeof protectedLayoutAdminIndexRoute
  '/help-center': typeof protectedLayoutHelpCenterIndexRoute
  '/materials': typeof protectedLayoutMaterialsIndexRoute
  '/menus': typeof protectedLayoutMenusIndexRoute
  '/recipes': typeof protectedLayoutRecipesIndexRoute
  '/recipes/$recipeId/edit': typeof protectedLayoutRecipesRecipeIdEditRoute
  '/companies': typeof protectedLayoutOrgCompaniesIndexRoute
  '/locations': typeof protectedLayoutOrgLocationsIndexRoute
  '/users': typeof protectedLayoutOrgUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(protected)/_layout': typeof protectedLayoutRouteWithChildren
  '/(public)/confirm-email': typeof publicConfirmEmailRoute
  '/(public)/forgot-password': typeof publicForgotPasswordRoute
  '/(public)/health': typeof publicHealthRoute
  '/(public)/login': typeof publicLoginRoute
  '/(public)/not-found': typeof publicNotFoundRoute
  '/(public)/onboarding': typeof publicOnboardingRouteWithChildren
  '/(public)/reset-password': typeof publicResetPasswordRoute
  '/(public)/sign-up': typeof publicSignUpRoute
  '/(public)/': typeof publicIndexRoute
  '/(protected)/_layout/_org': typeof protectedLayoutOrgRouteWithChildren
  '/(protected)/_layout/admin': typeof protectedLayoutAdminRouteWithChildren
  '/(protected)/_layout/dashboard': typeof protectedLayoutDashboardRoute
  '/(protected)/_layout/equipment': typeof protectedLayoutEquipmentRoute
  '/(protected)/_layout/impersonate': typeof protectedLayoutImpersonateRoute
  '/(protected)/_layout/multi-view': typeof protectedLayoutMultiViewRoute
  '/(protected)/_layout/new-order': typeof protectedLayoutNewOrderRoute
  '/(protected)/_layout/orders': typeof protectedLayoutOrdersRoute
  '/(protected)/_layout/organizations': typeof protectedLayoutOrganizationsRoute
  '/(protected)/_layout/prep': typeof protectedLayoutPrepRoute
  '/(protected)/_layout/profile': typeof protectedLayoutProfileRoute
  '/(protected)/_layout/rolesperms': typeof protectedLayoutRolespermsRoute
  '/(protected)/_layout/settings': typeof protectedLayoutSettingsRoute
  '/(protected)/_layout/unauthorized': typeof protectedLayoutUnauthorizedRoute
  '/(protected)/_layout/working': typeof protectedLayoutWorkingRoute
  '/(public)/onboarding/company': typeof publicOnboardingCompanyRoute
  '/(public)/onboarding/invite': typeof publicOnboardingInviteRoute
  '/(public)/onboarding/locations': typeof publicOnboardingLocationsRoute
  '/(public)/onboarding/organization': typeof publicOnboardingOrganizationRoute
  '/(public)/onboarding/plan': typeof publicOnboardingPlanRoute
  '/(public)/onboarding/regions': typeof publicOnboardingRegionsRoute
  '/(protected)/_layout/_org/regions': typeof protectedLayoutOrgRegionsRoute
  '/(protected)/_layout/_org/roles': typeof protectedLayoutOrgRolesRoute
  '/(protected)/_layout/admin/audit': typeof protectedLayoutAdminAuditRoute
  '/(protected)/_layout/admin/menus': typeof protectedLayoutAdminMenusRoute
  '/(protected)/_layout/companies_/$companyId': typeof protectedLayoutCompaniesCompanyIdRoute
  '/(protected)/_layout/help-center/$articleId': typeof protectedLayoutHelpCenterArticleIdRoute
  '/(protected)/_layout/locations_/$locationId': typeof protectedLayoutLocationsLocationIdRoute
  '/(protected)/_layout/materials/$materialId': typeof protectedLayoutMaterialsMaterialIdRoute
  '/(protected)/_layout/menus/$menuItemId': typeof protectedLayoutMenusMenuItemIdRoute
  '/(protected)/_layout/recipes/$recipeId': typeof protectedLayoutRecipesRecipeIdRoute
  '/(protected)/_layout/regions_/$regionId': typeof protectedLayoutRegionsRegionIdRoute
  '/(protected)/_layout/support/cleanup': typeof protectedLayoutSupportCleanupRoute
  '/(protected)/_layout/users_/$userId': typeof protectedLayoutUsersUserIdRoute
  '/(protected)/_layout/admin/': typeof protectedLayoutAdminIndexRoute
  '/(protected)/_layout/help-center/': typeof protectedLayoutHelpCenterIndexRoute
  '/(protected)/_layout/materials/': typeof protectedLayoutMaterialsIndexRoute
  '/(protected)/_layout/menus/': typeof protectedLayoutMenusIndexRoute
  '/(protected)/_layout/recipes/': typeof protectedLayoutRecipesIndexRoute
  '/(protected)/_layout/recipes/$recipeId_/edit': typeof protectedLayoutRecipesRecipeIdEditRoute
  '/(protected)/_layout/_org/companies/': typeof protectedLayoutOrgCompaniesIndexRoute
  '/(protected)/_layout/_org/locations/': typeof protectedLayoutOrgLocationsIndexRoute
  '/(protected)/_layout/_org/users/': typeof protectedLayoutOrgUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/confirm-email'
    | '/forgot-password'
    | '/health'
    | '/login'
    | '/not-found'
    | '/onboarding'
    | '/reset-password'
    | '/sign-up'
    | '/'
    | '/admin'
    | '/dashboard'
    | '/equipment'
    | '/impersonate'
    | '/multi-view'
    | '/new-order'
    | '/orders'
    | '/organizations'
    | '/prep'
    | '/profile'
    | '/rolesperms'
    | '/settings'
    | '/unauthorized'
    | '/working'
    | '/onboarding/company'
    | '/onboarding/invite'
    | '/onboarding/locations'
    | '/onboarding/organization'
    | '/onboarding/plan'
    | '/onboarding/regions'
    | '/regions'
    | '/roles'
    | '/admin/audit'
    | '/admin/menus'
    | '/companies/$companyId'
    | '/help-center/$articleId'
    | '/locations/$locationId'
    | '/materials/$materialId'
    | '/menus/$menuItemId'
    | '/recipes/$recipeId'
    | '/regions/$regionId'
    | '/support/cleanup'
    | '/users/$userId'
    | '/admin/'
    | '/help-center/'
    | '/materials/'
    | '/menus/'
    | '/recipes/'
    | '/recipes/$recipeId/edit'
    | '/companies/'
    | '/locations/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/confirm-email'
    | '/forgot-password'
    | '/health'
    | '/login'
    | '/not-found'
    | '/onboarding'
    | '/reset-password'
    | '/sign-up'
    | '/'
    | '/dashboard'
    | '/equipment'
    | '/impersonate'
    | '/multi-view'
    | '/new-order'
    | '/orders'
    | '/organizations'
    | '/prep'
    | '/profile'
    | '/rolesperms'
    | '/settings'
    | '/unauthorized'
    | '/working'
    | '/onboarding/company'
    | '/onboarding/invite'
    | '/onboarding/locations'
    | '/onboarding/organization'
    | '/onboarding/plan'
    | '/onboarding/regions'
    | '/regions'
    | '/roles'
    | '/admin/audit'
    | '/admin/menus'
    | '/companies/$companyId'
    | '/help-center/$articleId'
    | '/locations/$locationId'
    | '/materials/$materialId'
    | '/menus/$menuItemId'
    | '/recipes/$recipeId'
    | '/regions/$regionId'
    | '/support/cleanup'
    | '/users/$userId'
    | '/admin'
    | '/help-center'
    | '/materials'
    | '/menus'
    | '/recipes'
    | '/recipes/$recipeId/edit'
    | '/companies'
    | '/locations'
    | '/users'
  id:
    | '__root__'
    | '/(protected)/_layout'
    | '/(public)/confirm-email'
    | '/(public)/forgot-password'
    | '/(public)/health'
    | '/(public)/login'
    | '/(public)/not-found'
    | '/(public)/onboarding'
    | '/(public)/reset-password'
    | '/(public)/sign-up'
    | '/(public)/'
    | '/(protected)/_layout/_org'
    | '/(protected)/_layout/admin'
    | '/(protected)/_layout/dashboard'
    | '/(protected)/_layout/equipment'
    | '/(protected)/_layout/impersonate'
    | '/(protected)/_layout/multi-view'
    | '/(protected)/_layout/new-order'
    | '/(protected)/_layout/orders'
    | '/(protected)/_layout/organizations'
    | '/(protected)/_layout/prep'
    | '/(protected)/_layout/profile'
    | '/(protected)/_layout/rolesperms'
    | '/(protected)/_layout/settings'
    | '/(protected)/_layout/unauthorized'
    | '/(protected)/_layout/working'
    | '/(public)/onboarding/company'
    | '/(public)/onboarding/invite'
    | '/(public)/onboarding/locations'
    | '/(public)/onboarding/organization'
    | '/(public)/onboarding/plan'
    | '/(public)/onboarding/regions'
    | '/(protected)/_layout/_org/regions'
    | '/(protected)/_layout/_org/roles'
    | '/(protected)/_layout/admin/audit'
    | '/(protected)/_layout/admin/menus'
    | '/(protected)/_layout/companies_/$companyId'
    | '/(protected)/_layout/help-center/$articleId'
    | '/(protected)/_layout/locations_/$locationId'
    | '/(protected)/_layout/materials/$materialId'
    | '/(protected)/_layout/menus/$menuItemId'
    | '/(protected)/_layout/recipes/$recipeId'
    | '/(protected)/_layout/regions_/$regionId'
    | '/(protected)/_layout/support/cleanup'
    | '/(protected)/_layout/users_/$userId'
    | '/(protected)/_layout/admin/'
    | '/(protected)/_layout/help-center/'
    | '/(protected)/_layout/materials/'
    | '/(protected)/_layout/menus/'
    | '/(protected)/_layout/recipes/'
    | '/(protected)/_layout/recipes/$recipeId_/edit'
    | '/(protected)/_layout/_org/companies/'
    | '/(protected)/_layout/_org/locations/'
    | '/(protected)/_layout/_org/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  protectedLayoutRoute: typeof protectedLayoutRouteWithChildren
  publicConfirmEmailRoute: typeof publicConfirmEmailRoute
  publicForgotPasswordRoute: typeof publicForgotPasswordRoute
  publicHealthRoute: typeof publicHealthRoute
  publicLoginRoute: typeof publicLoginRoute
  publicNotFoundRoute: typeof publicNotFoundRoute
  publicOnboardingRoute: typeof publicOnboardingRouteWithChildren
  publicResetPasswordRoute: typeof publicResetPasswordRoute
  publicSignUpRoute: typeof publicSignUpRoute
  publicIndexRoute: typeof publicIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(public)/': {
      id: '/(public)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/sign-up': {
      id: '/(public)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof publicSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/reset-password': {
      id: '/(public)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof publicResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/onboarding': {
      id: '/(public)/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof publicOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/not-found': {
      id: '/(public)/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof publicNotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/login': {
      id: '/(public)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof publicLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/health': {
      id: '/(public)/health'
      path: '/health'
      fullPath: '/health'
      preLoaderRoute: typeof publicHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/forgot-password': {
      id: '/(public)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof publicForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/confirm-email': {
      id: '/(public)/confirm-email'
      path: '/confirm-email'
      fullPath: '/confirm-email'
      preLoaderRoute: typeof publicConfirmEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)/_layout': {
      id: '/(protected)/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof protectedLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/onboarding/regions': {
      id: '/(public)/onboarding/regions'
      path: '/regions'
      fullPath: '/onboarding/regions'
      preLoaderRoute: typeof publicOnboardingRegionsRouteImport
      parentRoute: typeof publicOnboardingRoute
    }
    '/(public)/onboarding/plan': {
      id: '/(public)/onboarding/plan'
      path: '/plan'
      fullPath: '/onboarding/plan'
      preLoaderRoute: typeof publicOnboardingPlanRouteImport
      parentRoute: typeof publicOnboardingRoute
    }
    '/(public)/onboarding/organization': {
      id: '/(public)/onboarding/organization'
      path: '/organization'
      fullPath: '/onboarding/organization'
      preLoaderRoute: typeof publicOnboardingOrganizationRouteImport
      parentRoute: typeof publicOnboardingRoute
    }
    '/(public)/onboarding/locations': {
      id: '/(public)/onboarding/locations'
      path: '/locations'
      fullPath: '/onboarding/locations'
      preLoaderRoute: typeof publicOnboardingLocationsRouteImport
      parentRoute: typeof publicOnboardingRoute
    }
    '/(public)/onboarding/invite': {
      id: '/(public)/onboarding/invite'
      path: '/invite'
      fullPath: '/onboarding/invite'
      preLoaderRoute: typeof publicOnboardingInviteRouteImport
      parentRoute: typeof publicOnboardingRoute
    }
    '/(public)/onboarding/company': {
      id: '/(public)/onboarding/company'
      path: '/company'
      fullPath: '/onboarding/company'
      preLoaderRoute: typeof publicOnboardingCompanyRouteImport
      parentRoute: typeof publicOnboardingRoute
    }
    '/(protected)/_layout/working': {
      id: '/(protected)/_layout/working'
      path: '/working'
      fullPath: '/working'
      preLoaderRoute: typeof protectedLayoutWorkingRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/unauthorized': {
      id: '/(protected)/_layout/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof protectedLayoutUnauthorizedRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/settings': {
      id: '/(protected)/_layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof protectedLayoutSettingsRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/rolesperms': {
      id: '/(protected)/_layout/rolesperms'
      path: '/rolesperms'
      fullPath: '/rolesperms'
      preLoaderRoute: typeof protectedLayoutRolespermsRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/profile': {
      id: '/(protected)/_layout/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof protectedLayoutProfileRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/prep': {
      id: '/(protected)/_layout/prep'
      path: '/prep'
      fullPath: '/prep'
      preLoaderRoute: typeof protectedLayoutPrepRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/organizations': {
      id: '/(protected)/_layout/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof protectedLayoutOrganizationsRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/orders': {
      id: '/(protected)/_layout/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof protectedLayoutOrdersRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/new-order': {
      id: '/(protected)/_layout/new-order'
      path: '/new-order'
      fullPath: '/new-order'
      preLoaderRoute: typeof protectedLayoutNewOrderRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/multi-view': {
      id: '/(protected)/_layout/multi-view'
      path: '/multi-view'
      fullPath: '/multi-view'
      preLoaderRoute: typeof protectedLayoutMultiViewRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/impersonate': {
      id: '/(protected)/_layout/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof protectedLayoutImpersonateRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/equipment': {
      id: '/(protected)/_layout/equipment'
      path: '/equipment'
      fullPath: '/equipment'
      preLoaderRoute: typeof protectedLayoutEquipmentRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/dashboard': {
      id: '/(protected)/_layout/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof protectedLayoutDashboardRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/admin': {
      id: '/(protected)/_layout/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof protectedLayoutAdminRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/_org': {
      id: '/(protected)/_layout/_org'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof protectedLayoutOrgRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/recipes/': {
      id: '/(protected)/_layout/recipes/'
      path: '/recipes'
      fullPath: '/recipes/'
      preLoaderRoute: typeof protectedLayoutRecipesIndexRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/menus/': {
      id: '/(protected)/_layout/menus/'
      path: '/menus'
      fullPath: '/menus/'
      preLoaderRoute: typeof protectedLayoutMenusIndexRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/materials/': {
      id: '/(protected)/_layout/materials/'
      path: '/materials'
      fullPath: '/materials/'
      preLoaderRoute: typeof protectedLayoutMaterialsIndexRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/help-center/': {
      id: '/(protected)/_layout/help-center/'
      path: '/help-center'
      fullPath: '/help-center/'
      preLoaderRoute: typeof protectedLayoutHelpCenterIndexRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/admin/': {
      id: '/(protected)/_layout/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof protectedLayoutAdminIndexRouteImport
      parentRoute: typeof protectedLayoutAdminRoute
    }
    '/(protected)/_layout/users_/$userId': {
      id: '/(protected)/_layout/users_/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof protectedLayoutUsersUserIdRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/support/cleanup': {
      id: '/(protected)/_layout/support/cleanup'
      path: '/support/cleanup'
      fullPath: '/support/cleanup'
      preLoaderRoute: typeof protectedLayoutSupportCleanupRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/regions_/$regionId': {
      id: '/(protected)/_layout/regions_/$regionId'
      path: '/regions/$regionId'
      fullPath: '/regions/$regionId'
      preLoaderRoute: typeof protectedLayoutRegionsRegionIdRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/recipes/$recipeId': {
      id: '/(protected)/_layout/recipes/$recipeId'
      path: '/recipes/$recipeId'
      fullPath: '/recipes/$recipeId'
      preLoaderRoute: typeof protectedLayoutRecipesRecipeIdRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/menus/$menuItemId': {
      id: '/(protected)/_layout/menus/$menuItemId'
      path: '/menus/$menuItemId'
      fullPath: '/menus/$menuItemId'
      preLoaderRoute: typeof protectedLayoutMenusMenuItemIdRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/materials/$materialId': {
      id: '/(protected)/_layout/materials/$materialId'
      path: '/materials/$materialId'
      fullPath: '/materials/$materialId'
      preLoaderRoute: typeof protectedLayoutMaterialsMaterialIdRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/locations_/$locationId': {
      id: '/(protected)/_layout/locations_/$locationId'
      path: '/locations/$locationId'
      fullPath: '/locations/$locationId'
      preLoaderRoute: typeof protectedLayoutLocationsLocationIdRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/help-center/$articleId': {
      id: '/(protected)/_layout/help-center/$articleId'
      path: '/help-center/$articleId'
      fullPath: '/help-center/$articleId'
      preLoaderRoute: typeof protectedLayoutHelpCenterArticleIdRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/companies_/$companyId': {
      id: '/(protected)/_layout/companies_/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof protectedLayoutCompaniesCompanyIdRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
    '/(protected)/_layout/admin/menus': {
      id: '/(protected)/_layout/admin/menus'
      path: '/menus'
      fullPath: '/admin/menus'
      preLoaderRoute: typeof protectedLayoutAdminMenusRouteImport
      parentRoute: typeof protectedLayoutAdminRoute
    }
    '/(protected)/_layout/admin/audit': {
      id: '/(protected)/_layout/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof protectedLayoutAdminAuditRouteImport
      parentRoute: typeof protectedLayoutAdminRoute
    }
    '/(protected)/_layout/_org/roles': {
      id: '/(protected)/_layout/_org/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof protectedLayoutOrgRolesRouteImport
      parentRoute: typeof protectedLayoutOrgRoute
    }
    '/(protected)/_layout/_org/regions': {
      id: '/(protected)/_layout/_org/regions'
      path: '/regions'
      fullPath: '/regions'
      preLoaderRoute: typeof protectedLayoutOrgRegionsRouteImport
      parentRoute: typeof protectedLayoutOrgRoute
    }
    '/(protected)/_layout/_org/users/': {
      id: '/(protected)/_layout/_org/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof protectedLayoutOrgUsersIndexRouteImport
      parentRoute: typeof protectedLayoutOrgRoute
    }
    '/(protected)/_layout/_org/locations/': {
      id: '/(protected)/_layout/_org/locations/'
      path: '/locations'
      fullPath: '/locations/'
      preLoaderRoute: typeof protectedLayoutOrgLocationsIndexRouteImport
      parentRoute: typeof protectedLayoutOrgRoute
    }
    '/(protected)/_layout/_org/companies/': {
      id: '/(protected)/_layout/_org/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof protectedLayoutOrgCompaniesIndexRouteImport
      parentRoute: typeof protectedLayoutOrgRoute
    }
    '/(protected)/_layout/recipes/$recipeId_/edit': {
      id: '/(protected)/_layout/recipes/$recipeId_/edit'
      path: '/recipes/$recipeId/edit'
      fullPath: '/recipes/$recipeId/edit'
      preLoaderRoute: typeof protectedLayoutRecipesRecipeIdEditRouteImport
      parentRoute: typeof protectedLayoutRoute
    }
  }
}

interface protectedLayoutOrgRouteChildren {
  protectedLayoutOrgRegionsRoute: typeof protectedLayoutOrgRegionsRoute
  protectedLayoutOrgRolesRoute: typeof protectedLayoutOrgRolesRoute
  protectedLayoutOrgCompaniesIndexRoute: typeof protectedLayoutOrgCompaniesIndexRoute
  protectedLayoutOrgLocationsIndexRoute: typeof protectedLayoutOrgLocationsIndexRoute
  protectedLayoutOrgUsersIndexRoute: typeof protectedLayoutOrgUsersIndexRoute
}

const protectedLayoutOrgRouteChildren: protectedLayoutOrgRouteChildren = {
  protectedLayoutOrgRegionsRoute: protectedLayoutOrgRegionsRoute,
  protectedLayoutOrgRolesRoute: protectedLayoutOrgRolesRoute,
  protectedLayoutOrgCompaniesIndexRoute: protectedLayoutOrgCompaniesIndexRoute,
  protectedLayoutOrgLocationsIndexRoute: protectedLayoutOrgLocationsIndexRoute,
  protectedLayoutOrgUsersIndexRoute: protectedLayoutOrgUsersIndexRoute,
}

const protectedLayoutOrgRouteWithChildren =
  protectedLayoutOrgRoute._addFileChildren(protectedLayoutOrgRouteChildren)

interface protectedLayoutAdminRouteChildren {
  protectedLayoutAdminAuditRoute: typeof protectedLayoutAdminAuditRoute
  protectedLayoutAdminMenusRoute: typeof protectedLayoutAdminMenusRoute
  protectedLayoutAdminIndexRoute: typeof protectedLayoutAdminIndexRoute
}

const protectedLayoutAdminRouteChildren: protectedLayoutAdminRouteChildren = {
  protectedLayoutAdminAuditRoute: protectedLayoutAdminAuditRoute,
  protectedLayoutAdminMenusRoute: protectedLayoutAdminMenusRoute,
  protectedLayoutAdminIndexRoute: protectedLayoutAdminIndexRoute,
}

const protectedLayoutAdminRouteWithChildren =
  protectedLayoutAdminRoute._addFileChildren(protectedLayoutAdminRouteChildren)

interface protectedLayoutRouteChildren {
  protectedLayoutOrgRoute: typeof protectedLayoutOrgRouteWithChildren
  protectedLayoutAdminRoute: typeof protectedLayoutAdminRouteWithChildren
  protectedLayoutDashboardRoute: typeof protectedLayoutDashboardRoute
  protectedLayoutEquipmentRoute: typeof protectedLayoutEquipmentRoute
  protectedLayoutImpersonateRoute: typeof protectedLayoutImpersonateRoute
  protectedLayoutMultiViewRoute: typeof protectedLayoutMultiViewRoute
  protectedLayoutNewOrderRoute: typeof protectedLayoutNewOrderRoute
  protectedLayoutOrdersRoute: typeof protectedLayoutOrdersRoute
  protectedLayoutOrganizationsRoute: typeof protectedLayoutOrganizationsRoute
  protectedLayoutPrepRoute: typeof protectedLayoutPrepRoute
  protectedLayoutProfileRoute: typeof protectedLayoutProfileRoute
  protectedLayoutRolespermsRoute: typeof protectedLayoutRolespermsRoute
  protectedLayoutSettingsRoute: typeof protectedLayoutSettingsRoute
  protectedLayoutUnauthorizedRoute: typeof protectedLayoutUnauthorizedRoute
  protectedLayoutWorkingRoute: typeof protectedLayoutWorkingRoute
  protectedLayoutCompaniesCompanyIdRoute: typeof protectedLayoutCompaniesCompanyIdRoute
  protectedLayoutHelpCenterArticleIdRoute: typeof protectedLayoutHelpCenterArticleIdRoute
  protectedLayoutLocationsLocationIdRoute: typeof protectedLayoutLocationsLocationIdRoute
  protectedLayoutMaterialsMaterialIdRoute: typeof protectedLayoutMaterialsMaterialIdRoute
  protectedLayoutMenusMenuItemIdRoute: typeof protectedLayoutMenusMenuItemIdRoute
  protectedLayoutRecipesRecipeIdRoute: typeof protectedLayoutRecipesRecipeIdRoute
  protectedLayoutRegionsRegionIdRoute: typeof protectedLayoutRegionsRegionIdRoute
  protectedLayoutSupportCleanupRoute: typeof protectedLayoutSupportCleanupRoute
  protectedLayoutUsersUserIdRoute: typeof protectedLayoutUsersUserIdRoute
  protectedLayoutHelpCenterIndexRoute: typeof protectedLayoutHelpCenterIndexRoute
  protectedLayoutMaterialsIndexRoute: typeof protectedLayoutMaterialsIndexRoute
  protectedLayoutMenusIndexRoute: typeof protectedLayoutMenusIndexRoute
  protectedLayoutRecipesIndexRoute: typeof protectedLayoutRecipesIndexRoute
  protectedLayoutRecipesRecipeIdEditRoute: typeof protectedLayoutRecipesRecipeIdEditRoute
}

const protectedLayoutRouteChildren: protectedLayoutRouteChildren = {
  protectedLayoutOrgRoute: protectedLayoutOrgRouteWithChildren,
  protectedLayoutAdminRoute: protectedLayoutAdminRouteWithChildren,
  protectedLayoutDashboardRoute: protectedLayoutDashboardRoute,
  protectedLayoutEquipmentRoute: protectedLayoutEquipmentRoute,
  protectedLayoutImpersonateRoute: protectedLayoutImpersonateRoute,
  protectedLayoutMultiViewRoute: protectedLayoutMultiViewRoute,
  protectedLayoutNewOrderRoute: protectedLayoutNewOrderRoute,
  protectedLayoutOrdersRoute: protectedLayoutOrdersRoute,
  protectedLayoutOrganizationsRoute: protectedLayoutOrganizationsRoute,
  protectedLayoutPrepRoute: protectedLayoutPrepRoute,
  protectedLayoutProfileRoute: protectedLayoutProfileRoute,
  protectedLayoutRolespermsRoute: protectedLayoutRolespermsRoute,
  protectedLayoutSettingsRoute: protectedLayoutSettingsRoute,
  protectedLayoutUnauthorizedRoute: protectedLayoutUnauthorizedRoute,
  protectedLayoutWorkingRoute: protectedLayoutWorkingRoute,
  protectedLayoutCompaniesCompanyIdRoute:
    protectedLayoutCompaniesCompanyIdRoute,
  protectedLayoutHelpCenterArticleIdRoute:
    protectedLayoutHelpCenterArticleIdRoute,
  protectedLayoutLocationsLocationIdRoute:
    protectedLayoutLocationsLocationIdRoute,
  protectedLayoutMaterialsMaterialIdRoute:
    protectedLayoutMaterialsMaterialIdRoute,
  protectedLayoutMenusMenuItemIdRoute: protectedLayoutMenusMenuItemIdRoute,
  protectedLayoutRecipesRecipeIdRoute: protectedLayoutRecipesRecipeIdRoute,
  protectedLayoutRegionsRegionIdRoute: protectedLayoutRegionsRegionIdRoute,
  protectedLayoutSupportCleanupRoute: protectedLayoutSupportCleanupRoute,
  protectedLayoutUsersUserIdRoute: protectedLayoutUsersUserIdRoute,
  protectedLayoutHelpCenterIndexRoute: protectedLayoutHelpCenterIndexRoute,
  protectedLayoutMaterialsIndexRoute: protectedLayoutMaterialsIndexRoute,
  protectedLayoutMenusIndexRoute: protectedLayoutMenusIndexRoute,
  protectedLayoutRecipesIndexRoute: protectedLayoutRecipesIndexRoute,
  protectedLayoutRecipesRecipeIdEditRoute:
    protectedLayoutRecipesRecipeIdEditRoute,
}

const protectedLayoutRouteWithChildren = protectedLayoutRoute._addFileChildren(
  protectedLayoutRouteChildren,
)

interface publicOnboardingRouteChildren {
  publicOnboardingCompanyRoute: typeof publicOnboardingCompanyRoute
  publicOnboardingInviteRoute: typeof publicOnboardingInviteRoute
  publicOnboardingLocationsRoute: typeof publicOnboardingLocationsRoute
  publicOnboardingOrganizationRoute: typeof publicOnboardingOrganizationRoute
  publicOnboardingPlanRoute: typeof publicOnboardingPlanRoute
  publicOnboardingRegionsRoute: typeof publicOnboardingRegionsRoute
}

const publicOnboardingRouteChildren: publicOnboardingRouteChildren = {
  publicOnboardingCompanyRoute: publicOnboardingCompanyRoute,
  publicOnboardingInviteRoute: publicOnboardingInviteRoute,
  publicOnboardingLocationsRoute: publicOnboardingLocationsRoute,
  publicOnboardingOrganizationRoute: publicOnboardingOrganizationRoute,
  publicOnboardingPlanRoute: publicOnboardingPlanRoute,
  publicOnboardingRegionsRoute: publicOnboardingRegionsRoute,
}

const publicOnboardingRouteWithChildren =
  publicOnboardingRoute._addFileChildren(publicOnboardingRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  protectedLayoutRoute: protectedLayoutRouteWithChildren,
  publicConfirmEmailRoute: publicConfirmEmailRoute,
  publicForgotPasswordRoute: publicForgotPasswordRoute,
  publicHealthRoute: publicHealthRoute,
  publicLoginRoute: publicLoginRoute,
  publicNotFoundRoute: publicNotFoundRoute,
  publicOnboardingRoute: publicOnboardingRouteWithChildren,
  publicResetPasswordRoute: publicResetPasswordRoute,
  publicSignUpRoute: publicSignUpRoute,
  publicIndexRoute: publicIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
